import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

function BODButton() {
  const location = useLocation(); // Get the current location
  const [activeButton, setActiveButton] = useState(location.pathname); // Set the default active button based on the current path

  return (
    <div className="bod-button">
      <Link to="/about/corporate-profile/board-of-directors">
        <Button
          className={
            activeButton === "/corporate-profile/board-of-directors"
              ? "btn-item-active"
              : "btn-item"
          }
          onClick={() =>
            setActiveButton("/corporate-profile/board-of-directors")
          }
        >
          Board of Directors
        </Button>
      </Link>

      <Link to="/about/corporate-profile/shariah-board">
        <Button
          className={
            activeButton === "/corporate-profile/shariah-board"
              ? "btn-item-active"
              : "btn-item"
          }
          onClick={() => setActiveButton("/corporate-profile/shariah-board")}
        >
          Shariah Board
        </Button>
      </Link>

      <Link to="/about/corporate-profile/executive-management">
        <Button
          className={
            activeButton === "/corporate-profile/executive-management"
              ? "btn-item-active"
              : "btn-item"
          }
          onClick={() =>
            setActiveButton("/corporate-profile/executive-management")
          }
        >
          Executive Management
        </Button>
      </Link>
    </div>
  );
}

export default BODButton;
